/**
 * Converts a chromogen only kit to a consumer form state.
 * @return ChromogenKitForm
 */
export var chromogenOnlyCishKitToConsumerFormState = function (catalog, kit) {
    var protocolType;
    var scale;
    var chromogen;
    protocolType = catalog.cishProtocols.find(function (p) { return p.id === kit.protocolType.id; });
    scale = catalog.cishChromogens.proChromogenScales.find(function (s) { var _a; return s === ((_a = kit.chromogenComponent) === null || _a === void 0 ? void 0 : _a.chromogenScale.slides); });
    chromogen = catalog.cishChromogens.chromogens.find(function (c) { var _a, _b; return c.id === ((_b = (_a = kit.chromogenComponent) === null || _a === void 0 ? void 0 : _a.chromogen) === null || _b === void 0 ? void 0 : _b.id); });
    return {
        protocolType: protocolType,
        scale: scale,
        chromogen: chromogen,
        errors: [],
        price: undefined,
        priceLoading: false,
        comment: ""
    };
};
//# sourceMappingURL=ChromogenOnlyCishKitToConsumerFormState.js.map


//////////////////
// WEBPACK FOOTER
// ../common/build/dist/kit/rna-cish/ChromogenOnlyCishKitToConsumerFormState.js
// module id = 573
// module chunks = 0